import gql from "graphql-tag";

export const DELETE_ONE_ATTENDANCE_STEP = gql`
  mutation ($id: ID!) {
    deleteOneAttendanceStep(input: { id: $id }) {
      id
    }
  }
`;
